import BackendDeveloperPage from "./BackendDeveloperPage";

export default function DevOpsDeveloperPage() {
  return <BackendDeveloperPage technology="devops" />;
}
